import React from 'react';
import { NoDataComponent } from './style';

const NoData = ({ width }) => {
  return (
    <NoDataComponent
      width={width}
      image='https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg'
      imageStyle={{
        height: 60,
      }}
      description={<span className='noData'>No data</span>}
    />
  );
};

export default NoData;
